import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_URL } from '../../../config';
import { USER_DATA_ENDPOINTS } from '../../../constants/endpoints/userData';
import { getFromStorage, saveToStorage } from '../../../guards/Encrypt';
import { USER_PERMISSIONS } from '../../../constants/user-permissions';

export const login = createAsyncThunk('auth/login', async ({ email, password }, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}/${USER_DATA_ENDPOINTS.login}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      return rejectWithValue(errorData);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    return rejectWithValue({ message: 'Error de red' });
  }
});

const initialState = {
  user: getFromStorage('user') || null,
  token: localStorage.getItem('token') || null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/login';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
        saveToStorage('user', action.payload.user);
        localStorage.setItem('token', action.payload.token);

        // Redirigir al usuario según su rol
        const userRole = action.payload.user.rol;
        const defaultPath = USER_PERMISSIONS[userRole]?.[0] || '/unauthorized';
        window.location.href = defaultPath;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;